import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_91: FaireProductEntity = {
  token: "catalog_prod_prod-91",
  type: "product",
  name: "Decorative Item B",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 11.55,
  msrpDollars: 28.88,
  sku: "CA0091",
  caseSize: 12,
  material: "Cotton",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 31,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
